import { Component } from '@angular/core';
import { PlausibleService } from './plausible.service';

@Component({
  selector: 'home',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent {
  title = 'Dash';

  constructor(public plausible: PlausibleService) {}
}
